import {Component, inject, OnInit} from '@angular/core';
import {FormsModule}               from '@angular/forms';
import {ActivatedRoute, Router}    from '@angular/router';
import {AuthUnlockService}         from '../../utils/auth-unlock.service';
import {AuthWrapperComponent}      from '../auth-wrapper/auth-wrapper.component';

@Component({
			   selector   : 'app-auth-unlock',
			   imports    : [
				   FormsModule,
				   AuthWrapperComponent
			   ],
			   templateUrl: './auth-unlock.component.html',
			   styleUrl   : './auth-unlock.component.css'
		   })
export class AuthUnlockComponent implements OnInit {
	svcAuthUnlock = inject(AuthUnlockService)
	route = inject(ActivatedRoute)
	router = inject(Router)

	passphrase = '';
	errorMessage = '';
	unlocked = false;

	returnUrl = '/home';

	loading = true;

	constructor() {
		this.returnUrl = this.route.snapshot.queryParamMap.get('returnUrl') || '/home';

	}


	async ngOnInit() {
		const unlocked = await this.svcAuthUnlock.tryFaceIdUnlock();

		if (unlocked) {
			await this.router.navigateByUrl('/home');
		} else {
			this.loading = false; // show passphrase screen
		}
	}

	async faceId() {
		const unlocked = await this.svcAuthUnlock.unlockWithFaceId();
		if (unlocked) {
			await this.router.navigateByUrl(this.returnUrl); // or whatever your dashboard route is
		}
	}

	async unlock() {
		try {
			await this.svcAuthUnlock.unlockWithPassphrase(this.passphrase);

			// ✅ Register FaceID for future
			await this.svcAuthUnlock.setupFaceIdCredential();

			const isValid = await this.svcAuthUnlock.verifyPassphraseKey();

			if (isValid) {
				this.unlocked = true; // For test display
				await this.router.navigateByUrl(this.returnUrl);
			} else {
				// const confirmed = confirm(
				// 	'No unlock-check exists. Is this your first time unlocking with this passphrase?'
				// );
				//
				// if (confirmed) {
				// 	await this.svcAuthUnlock.createInitialUnlockCheck();
				// 	this.unlocked = true;
				// 	// this.router.navigateByUrl('/dashboard');
				// } else {
				// 	this.svcAuthUnlock.lock();
				// 	this.errorMessage = 'Unlock failed — incorrect passphrase.';
				// }
			}
		} catch (error) {
			console.error(error);
			this.errorMessage = 'Unlock error. Please try again.';
		}
	}
}